"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var IconArrowDropUp = function IconArrowDropUp(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 24 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 24 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$customClass = _ref.customClass,
      customClass = _ref$customClass === void 0 ? '' : _ref$customClass;
  return (0, _preact.h)("svg", {
    width: width,
    height: height,
    className: customClass,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, (0, _preact.h)("path", {
    d: "M7 14L12 9L17 14H7Z",
    fill: color
  }));
};

var _default = IconArrowDropUp;
exports.default = _default;